<i18n src="./resources/locales.json"></i18n>
<template>
  <div>
    <input id="upload-input" ref="uploadInput" type="file" name="filename" hidden multiple @change="performUpload" />
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon small v-bind="attrs" v-on="on" @click="uploadFiles">
          <v-icon>
            mdi-paperclip
          </v-icon>
        </v-btn>
      </template>
      <span v-once>{{ $t('attachFiles') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'EcsAttachFiles',
  props: {
    interactionId: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions('INTERACTIONS/emails', ['addOutgoingAttachments']),
    uploadFiles() {
      this.$refs.uploadInput.click();
    },
    performUpload() {
      const attachments = [];
      this.$refs.uploadInput.files.forEach(file => {
        attachments.push({ id: uuidv4(), file, name: file.name, contentType: file.type, error: false });
      });
      this.addOutgoingAttachments({ interactionId: this.interactionId, attachments });
      this.$refs.uploadInput.value = null;
    }
  }
};
</script>

<style></style>
